namespace Areas.Requests {
    "user strict";

    var selected: Selected = new Selected();

    export function onUserIDValueChanged(rowData, value) {
        return userValueChanged(selected)(rowData, value);
    }

    export function userLookupEditTemplate(cellElement, cellInfo) {
        return lookupEditTemplate("/Requests/ProjectInfoUser/Users", selected)(cellElement, cellInfo);
    }

    export function userLookupCellTemplate(cellElement, cellInfo) {
        return lookupCellTemplate(cellElement, cellInfo);
    }

    export function newProjectInfoUser(e) {

        var dataGrid = $('#UserInfoGrid').dxDataGrid('instance');
        var projectInfoId = dataGrid.option('ProjectInfoId');

        e.data.projectInfoId = projectInfoId;
    }

    export function newProjectInfoRecharge(e) {

        var dataGrid = $('#RechargeInfoGrid').dxDataGrid('instance');
        var projectInfoId = dataGrid.option('ProjectInfoId');

        e.data.projectInfoId = projectInfoId;
    }
}